import { render, staticRenderFns } from "./Advertiser.vue?vue&type=template&id=b6b542be&scoped=true"
import script from "./Advertiser.vue?vue&type=script&lang=js"
export * from "./Advertiser.vue?vue&type=script&lang=js"
import style0 from "./Advertiser.vue?vue&type=style&index=0&id=b6b542be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b542be",
  null
  
)

export default component.exports